import { takeEvery, put, all } from 'redux-saga/effects';

import * as types from '../../actions/admin/audit/types';
import * as actions from '../../actions/admin/audit';
import { setListSettings } from '../../actions/list-settings';

import listNames from '../../constants/list-names';

import { getListSettingsFromQueryParams } from '../../tools';
import apiFetcher from '../../tools/api-fetcher';
import queryStringify from '../../tools/query-stringify';
import handleError from '../../tools/error-helper';

function* getAdminAuditLogs({ queryParams }) {
  yield put(actions.setAdminAuditLogsLoading(true));

  try {
    const { data } = yield apiFetcher
      .auth()
      .get(`admins/audit/log?${queryStringify({ ...queryParams })}`);

    yield put(actions.setAdminAuditLogs(data));

    const listSettings = yield getListSettingsFromQueryParams(queryParams);
    
    yield put(setListSettings(listNames.adminAudit, listSettings)); 
  } catch (exception) {
    handleError(exception, 'Failed to load audit logs.');
  }

  yield put(actions.setAdminAuditLogsLoading(false));
}

export default function* adminAuditLogsSaga() {
  yield all([
    takeEvery(types.ADMIN_AUDIT_GET_LOGS, getAdminAuditLogs)
  ]);
}


// WEBPACK FOOTER //
// ./src/sagas/admin/admin-audit.js